import getClient from '../getClient';
import { User } from '../user';

export type ApiUsers = {
  data: User[];
};

export type ApiUserConfigs = {
  data: {
    meeting_identifier: string;
    user_id: number;
  }[];
};

const users = (): Promise<ApiUsers> =>
  getClient().get('api/v2/users/basic_index').json();

export const userConfigs = (userId: number): Promise<ApiUserConfigs> => {
  const searchParams = new URLSearchParams({
    user_ids: userId.toString(),
  });
  return getClient()
    .get('api/v2/user_configs/search', {
      searchParams,
    })
    .json();
};

export default users;
